export const getFormStyles = (isDarkMode: boolean) => {
  return {
    container: {
      paddingLeft: "15vw",
      paddingRight: "15vw",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    },
    label: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    input: {
      fontSize: "1.2rem",
      backgroundColor: isDarkMode ? "#404040" : "#ffffff",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      border: isDarkMode ? "1px solid #f0f0f0" : "1px solid #201b41",
      borderRadius: ".5rem",
      padding: ".75rem",
      "&::placeholder": {
        color: isDarkMode ? "#b2b2b2" : "#888888",
      },
    },
    textarea: {
      fontSize: "1.2rem",
      backgroundColor: isDarkMode ? "#404040" : "#ffffff",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      border: isDarkMode ? "1px solid #f0f0f0" : "1px solid #201b41",
      borderRadius: ".5rem",
      padding: ".75rem",
    },
    select: {
      fontSize: "1.2rem",
      backgroundColor: isDarkMode ? "#404040" : "#ffffff",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      border: isDarkMode ? "1px solid #f0f0f0" : "1px solid #201b41",
      borderRadius: ".5rem",
      padding: ".75rem",
    },
    error: {
      color: isDarkMode ? "#f0f0f0" : "red",
      fontWeight: "bold",
      fontSize: "1.2rem",
      backgroundColor: isDarkMode ? "red" : "transparent",
      width: "fit-content",
      padding: ".5rem",
      borderRadius: ".5rem",
    },
    numberInput: {
      fontSize: "1.2rem",
      backgroundColor: isDarkMode ? "#404040" : "#ffffff",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      border: isDarkMode ? "1px solid #f0f0f0" : "1px solid #201b41",
      borderRadius: ".5rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: ".75rem",
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        textAlign: "center",
        fontSize: "1.2rem",
      },
      "&:focus-within": {
        borderColor: isDarkMode ? "#ffffff" : "#201b41",
      },
      "& .mantine-NumberInput-controls": {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
      },
      "& .mantine-NumberInput-control": {
        backgroundColor: isDarkMode ? "#505050" : "#dcdcdc",
        borderRadius: ".25rem",
        padding: ".25rem",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: isDarkMode ? "#606060" : "#c4c4c4",
        },
      },
    },
    checkbox: {
      fontSize: "1.2rem",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      "& .mantine-Checkbox-input": {
        border: isDarkMode ? "1px solid #f0f0f0" : "1px solid #201b41",
        backgroundColor: isDarkMode ? "#404040" : "#ffffff",
        borderRadius: "0.1rem",
        width: "1.2rem",
        height: "1.2rem",
        "&:checked": {
          backgroundColor: isDarkMode ? "#f0f0f0" : "#201b41",
          borderColor: isDarkMode ? "#f0f0f0" : "#201b41",
          "&:before": {
            color: isDarkMode ? "#201b41" : "#f0f0f0",
          },
        },
      },
      "& .mantine-Checkbox-label": {
        fontSize: "1.2rem",
        color: isDarkMode ? "#f0f0f0" : "#201b41",
      },
      "& .mantine-Checkbox-checked": {
        backgroundColor: isDarkMode ? "#f0f0f0" : "#201b41",
      },
      "&:hover .mantine-Checkbox-input": {
        borderColor: isDarkMode ? "#f0f0f0" : "#201b41",
      },
    },
  };
};
